import { AffiliateControllerResponse } from '../../../../types/controllers/affiliate';
import { BannerPromotion } from '../../types';

import { getPromotionImage } from '../../utils';

export const BANNER_BREAKPOINT = 800;

export function getImageSize(width: number): 'desktopBanner' | 'mobileBanner' {
    return width > BANNER_BREAKPOINT ? 'desktopBanner' : 'mobileBanner';
}

function isExpired(timeString: string): boolean {
    return new Date(timeString).getTime() < new Date().getTime();
}

export function getPromos(placement: AffiliateControllerResponse): Array<BannerPromotion> {
    const promotions = placement.promotions;
    const canUseAlternateLink = placement.allow_alternate_link;
    const promotionListId = placement.id;

    const formattedPromotions = promotions.map(promotion => ({
        id: promotion.id,
        bookId: promotion.affiliate.id,
        campaignId: promotion.campaign.id,
        promotionListId: promotionListId,
        isActive: promotion.expires_at ? !isExpired(promotion.expires_at) : false,
        desktopBanner: getPromotionImage(promotion.images, 'desktop_banner') || '',
        mobileBanner: getPromotionImage(promotion.images, 'app_game_page_ad') || '',
        logoColor: promotion.affiliate.primary_color || '',
        alternateLink: canUseAlternateLink && promotion.alternate_link ? promotion.alternate_link : '',
        impressionUrls: promotion.additional_attributes.impression_urls_meta || [],
        switchboard_domain: promotion.switchboard_domain || null,
        impressionTtl: promotion.affiliate.impression_ttl || 86400,
        impressionThrottle: promotion.affiliate.impression_throttle || 1,
        impressionThrottleClick:
            promotion.affiliate.impression_throttle_click || promotion.affiliate.impression_throttle || 1,
        affiliateId: promotion.affiliate.id,
    }));

    const activePromosWithBanners = formattedPromotions.filter(
        promotion => !!promotion.desktopBanner && !!promotion.mobileBanner && promotion.isActive
    );

    return activePromosWithBanners;
}
